/** @flow */
import type { SpawnEffect } from "redux-saga";
import { spawn } from "redux-saga/effects";
import overviewSaga from "./overview";
import reportSaga from "./report";

export default function* focusListSaga(): Generator<
  SpawnEffect<*, typeof reportSaga, *>,
  void,
  void,
> {
  yield spawn(overviewSaga);
  yield spawn(reportSaga);
}
